<template>
  <div class="stake-n-return" v-if="showMoneyInput && (currentBetSlipState<=1 || stake)">
    <div class="stake-line"  >

      <span class="stake">
        <money-input
          v-model="stake"
          :id="1"
          :inputType="'wager'"
          :placeholder="placeholder.wager"
          :focus="focus"
          @setFocus="setFocus"
          @dismissError="dismissError"
          :currentBetSlipState="currentBetSlipState"
          :stakeChanged="!!(stakeChange && stakeChange.old && [5, 6].includes(currentBetSlipState) && (inRefferalStakeChanged || nonReferalStakeChanged))"
          :stakeChange="stakeChange"
          @hasError="hasError"
          :perType="perType"
          :minStake="minStake[perType]"
          :maxStake="maxStake[perType]"
          :statusToConfirm="statusToConfirm"
          :disabledByVoucher="disabledByVoucher"
          ref="wagerInput"
        ></money-input>
      </span>

      <span class="returns">
        <money-input
          v-model="winning"
          :id="2"
          :inputType="'winning'"
          :placeholder="placeholder.winning"
          :focus="focus"
          @setFocus="setFocus"
          @dismissError="dismissError"
          :currentBetSlipState="currentBetSlipState"
          @hasError="hasError"
          :perType="perType"
          :minStake="minStake[perType]"
          :maxStake="maxStake[perType]"
          :statusToConfirm="statusToConfirm"
          :disabledByVoucher="disabledByVoucher"
        ></money-input>
      </span>

    </div>

    <div class="voucher voucherData" v-if="applicableVoucher && (applicableVoucher.MinStake || applicableVoucher.MaxStake) && (!discount || discount<=0.0001)">
      <span class="voucherMinStake" v-if="applicableVoucher.MinStake"><span>{{$t('Betslip.voucher.minStake')}}: </span>{{currencySymbol}}{{applicableVoucher.MinStake}}</span><span
            class="voucherMaxStake" v-if="applicableVoucher.MaxStake"><span><span v-if="applicableVoucher.MinStake">; </span>{{$t('Betslip.voucher.maxStake')}}: </span>{{currencySymbol}}{{applicableVoucher.MaxStake}}</span>
    </div>
    <div v-else-if="voucher || (discount && applicableVoucher && applicableVoucher.DiscountPercentage)" class="voucher">
      {{ $t('BetSlip.StakeAdReturn.promotions.discount') }}: <span class="discount">{{ currencySymbol }}{{(voucher || discount).toFixed(2)}}</span>
    </div>

    <div v-if="hasErrors" class="error-msg">
      <v-icon>info_outline</v-icon>
      <div v-for="e in errors">
        <span :key="e" v-if="e" :id="perType + 'BetSlipErrorMessageId'">
          {{ $t('BetSlip.stakeNreturn.error.' + e, {min:minStake[perType], max:maxStake[perType], currency: currencySymbol}) }}</span>
      </div>
    </div>

    <promotion-vouchers
      :allowedBetTypesAndReturns="allowedBetTypesAndReturns"
      :tab="tab"
      :currentBetSlipState="currentBetSlipState"
      :isFastBet="isFastBet"
      @dismissError="dismissError" ></promotion-vouchers>

<!--    <br>tab: {{tab}}-->
    <!--<br>id: {{id}}-->
    <!--<br>derivativeId: {{derivativeId}}-->
    <!--<br>stake: {{stake}}-->
    <!--<br>winning: {{winning}}-->
    <!--<br>hasErrors: {{hasErrors}}-->
    <!--<br>errors: {{errors}}-->
    <!--<br>perType: {{perType}}-->
<!--    <br><b>betTypeStakes:</b> {{betTypeStakes[tab]}}-->
<!--    <br><b>betTypeStake:</b> {{betTypeStake}}-->
    <!--<br><b>winnings:</b> {{winnings[tab]}}-->
<!--    <br><b>betTypeStakes:</b> {{betTypeStakes}}-->
<!--    <br>winning: {{winning}}-->
    <!--<br>potentialReturn: {{potentialReturn}}-->
    <!--<br>unitCount: {{unitCount}}-->
<!--    <br>allowedBetTypesAndReturns: {{allowedBetTypesAndReturns}}-->
    <!--<br>currentBetSlipState: {{currentBetSlipState}}-->
    <!--<br>inRefferal: {{inRefferal}}-->
    <!--<br>stakeChange: {{stakeChange}}-->
    <!--<br>promotionsData: {{promotionsData}}-->
    <!--<br>voucher: {{voucher}}-->
    <!--<br>teaserGroupId: {{teaserGroupId}}-->
    <!--<br>isFastBet: {{isFastBet}}-->
<!--    <br>unitCount: {{unitCount}}-->
<!--    <br>potentialReturn: {{potentialReturn}}-->
<!--    <br>appliedVoucherId: {{appliedVoucherId}}-->
<!--    <br>appliedVoucher: {{appliedVoucher}}-->
<!--    <br>discount: {{discount}}-->
<!--    <br>applicableVoucher: {{applicableVoucher}}-->
<!--    <br>appliedVoucherId: {{appliedVoucherId}}-->

<!--    <br>isVoucherAppliedHere: {{isVoucherAppliedHere}}-->
<!--    <br>disabledByVoucher: {{disabledByVoucher}}-->
<!--    <br>specialOffers:  <div v-html="printJSON(specialOffers)"></div><br><hr>-->
<!--    <br>applicableVoucher:  <div v-html="printJSON(applicableVoucher)"></div><hr>-->
<!--    <br>appliedVoucher: <div v-html="printJSON(appliedVoucher)"></div>-->
</div>
</template>

<script>
  import Vue from 'vue'
  import config from '@/config'
  import store from '@/store'
  import moneyInput from './moneyInput'
  import Icon from '@/components/common/Icon'
  import promotionVouchers from '../promotionVouchers/vouchers'
  import priceFormat from '@/library/priceFormat'

  export default {
    name: 'stakeNreturn',

    mixins: [],

    props: ['id', 'perType', 'tab', 'currentBetSlipState', 'allowedBetTypesAndReturns', 'teaserGroupId',
      'isSGM', 'sgmPath', 'isFastBet', 'derivativeId', 'statusToConfirm'],

    components: {
      Icon,
      moneyInput,
      promotionVouchers
    },

    data () {
      return {
        setter: null,
        focus: [0],
        stakeChange: {},
        inRefferalStakeChanged: false,
        nonReferalStakeChanged: false,
        errors: {},
        freshFromGet: false,
        showMoneyInput: true,
        unitStakeIncrement: 0.01
      }
    },

    computed: {
      minStake () {
        return store.getters['sbBetslipState/minStake']
      },
      maxStake () {
        return store.getters['sbBetslipState/maxStake']
      },
      inRefferal () {
        return store.getters['sbBetslipState/inRefferal']
      },
      betTypeStakes () {
        return store.getters['sbBetslipState/betTypeStakes']
      },
      multiSinglesStake () {
        return store.getters['sbBetslipState/multiSinglesStake']
      },
      betTypeStake () {
        if (this.isSGM && this.tab === 'XP') {
          var betTypeStakes
          if (this.sgmPath && this.sgmPath.length) {
            betTypeStakes = this.betTypeStakes
            this.sgmPath.forEach(function (p) {
              betTypeStakes = betTypeStakes[p]
            })
          } else {
            betTypeStakes = this.betTypeStakes.XP.PerEvent
          }
          return betTypeStakes
        }
        return this.tab === 'TEASER' ? this.betTypeStakes[this.tab][this.teaserGroupId][this.perType] : this.betTypeStakes[this.tab][this.perType]
      },
      unitCount () {
        if (this.isSGM) {
          return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.UnitCount
        }
        return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.UnitCount
      },
      potentialReturn () {
        if (this.isSGM) {
          return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.PotentialReturn
        }
        return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.PotentialReturn
      },
      placeholder () {
        return {
          wager: this.$t('BetSlip.input.placeholder.wager'),
          winning: this.$t('BetSlip.input.placeholder.return')
        }
      },
      stake: {
        get: function () {
          let s = this.betTypeStake[this.id]
          // console.log('Get stake (' + this.id + '): ' + s, 'disabledByVoucher:', this.disabledByVoucher)
          var self = this
          self.freshFromGet = true
          setTimeout(function () {
            self.freshFromGet = false
          }, 0)
          if (s && this.disabledByVoucher) {
            self.freshFromGet = false
            this.stake = ''
            s = ''
          }
          return s
        },
        set: function (v) {
          // console.log('set stake (' + this.id + '): ' + v + '; (' + typeof v + '); freshFromGet: ' + this.freshFromGet, '; setter:', this.setter)
          if (!this.freshFromGet) {
            Vue.set(this.betTypeStake, this.id, v)
          }
          this.freshFromGet = false
          // let vOK = v || [0, '0', ''].includes(v)
          if (typeof v === 'number' && this.isFastBet) {
            store.commit('sbBetslipState/setSingleBetSlipStake', v)
          }
          if (this.unitCount && (!this.setter)) {
            this.setter = this.setter || 'wager'
            this.calculateWinning(v, 'stake-Set')
          }
          this.setter = null
        }
      },
      winnings () {
        return store.getters['sbBetslipState/returns']
      },
      winningPerTab () {
        if (this.isSGM && this.tab === 'XP') {
          return this.winnings.XP.PerEvent
        }
        return this.tab === 'TEASER' ? this.winnings[this.tab][this.teaserGroupId][this.perType] : this.winnings[this.tab][this.perType]
      },
      winning: {
        get: function () {
          let w = this.winningPerTab[this.id]
//          console.log('get winning (' + this.id + '): ' + w)
          return w
        },
        set: function (v) {
          // console.log('set winning (' + this.id + '): ' + v + ' (' + typeof v + ')' + '; setter: ' + this.setter)
          Vue.set(this.winningPerTab, this.id, v)
          if (this.unitCount && (!this.setter)) {
            this.setter = this.setter || 'winning'
            this.calculateStake(v, 'winning-set')
          }
          this.setter = null
        }
      },

      hasErrors () {
        return this.errors.wager || this.errors.winning
      },
      promotionsData () {
        var promotionsData = store.getters['sbBetslipState/promotionsData']
        // console.log('promotionsData per', this.tab)
//        console.log(promotionsData)
        if (this.isSGM && this.tab === 'XP') {
          promotionsData = promotionsData && promotionsData.XP
        } else {
          promotionsData = promotionsData && promotionsData[this.tab]
          if (this.tab === 'TEASER') {
            promotionsData = promotionsData && promotionsData[this.teaserGroupId]
          }
        }
        promotionsData = promotionsData || {}
        return promotionsData
      },
      voucher () {
        var voucher = this.promotionsData || 0
        var id = this.derivativeId || this.id
        if (this.isSGM && this.tab === 'XP') {
          voucher = voucher.PerEvent && voucher.PerEvent[this.id]
        } else {
          if (typeof id === 'number') {
            voucher = voucher.PerSelection && voucher.PerSelection[id]
          } else {
            voucher = voucher.PerBetType && voucher.PerBetType[id]
          }
        }
        return voucher
      },
      currencySymbol () {
        return config.app.CURRENCY
      },
      betId () {
        if (this.isSGM) {
          return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.betId
        }
        return this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.betId
      },
      autoFillStakeByVoucher () {
        return store.getters['sbBetslipState/autoFillStakeByVoucher']
      },
      disableOtherBetsByVoucher () {
        return store.getters['sbBetslipState/disableOtherBetsByVoucher']
      },
      availableVouchers () {
        return store.getters['sbBetslipState/getAvailableVouchers'] || []
      },
      betslipTab () {
        let tab = this.tab === 'XP' ? 'REGULAR' : this.tab
        return tab
      },
      specialOffers () {
        let specialOffers = this.allowedBetTypesAndReturns && (this.allowedBetTypesAndReturns.SpecialOffers || this.allowedBetTypesAndReturns.SpecialOffer)
        let eligibleSO = (specialOffers && specialOffers['0']) || []
        return eligibleSO
      },
      appliedVoucher () {
        let appliedVoucher = store.getters['sbBetslipState/appliedVoucher'](this.betslipTab) || null
        // console.log('appliedVoucher for', this.betId, ':', appliedVoucher)
        return appliedVoucher
      },
      appliedVoucherId () {
        let voucher = this.appliedVoucher
        return (voucher && voucher.isActive && voucher.id) || null
      },
      applicableVouchers () {
        return (this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.applicableVouchers) || []
      },
      applicableVoucher () {
        let voucher = null
        if (this.appliedVoucherId && this.allowedBetTypesAndReturns) {
          let [IDMMPRVoucher, betId] = this.appliedVoucherId.split('|')
          let availableVouchersIds = this.availableVouchers.map(v => v.IDMMPRVoucher + '')
          // console.log('allowedBetTypesAndReturns:', allowedBetTypesAndReturns)
          if (availableVouchersIds.includes(IDMMPRVoucher) && this.allowedBetTypesAndReturns.betId === betId) {
            voucher = this.applicableVouchers &&
              this.applicableVouchers.find(v => (v.IDMMPRVoucher + '') === IDMMPRVoucher)
          }
        }
        return voucher || null
      },
      isVoucherAppliedHere () {
        let isVoucherAppliedHere = this.appliedVoucherId &&
          // this.applicableVoucher && this.applicableVoucher.IDMMPRVoucher &&
          // this.appliedVoucherId === this.applicableVoucher.IDMMPRVoucher + '|' + this.betId
          this.appliedVoucherId.indexOf(this.betId) > -1
        return !!isVoucherAppliedHere
      },
      disabledByVoucher () {
        return this.disableOtherBetsByVoucher && this.appliedVoucherId && !this.isVoucherAppliedHere && this.appliedVoucher && this.appliedVoucher.isBetAvailable
      },
      discount: {
        get: function () {
          let stake = this.stake || 0
          let voucher = this.applicableVoucher
          let discount = voucher ? 0.000000001 : 0
          if (stake && voucher) {
            discount = 0.0000001
            discount = Number(Number(stake).toFixed(2)) * this.unitCount
            discount = Number(Number(discount).toFixed(2))
            let minStake = voucher.MinStake || 0
            let maxStake = voucher.MaxStake || 0
            let discountPercentage = voucher.DiscountPercentage || 0
            let maxAmount = voucher.CurrentAmount || 0
            //
            if (minStake && discount < minStake) {
              discount = 0.000001
            }
            if (maxStake && discount > maxStake) {
              discount = maxStake
            }
            if (discountPercentage) {
              discount = (discount * discountPercentage) / 100
            } else {
              discount = 0.00000001
            }
            // discount = discount === 0.0000001 ? discount : Number(Number(discount).toFixed(2))
            if (discount > maxAmount) {
              discount = maxAmount
            }
            discount = discount <= 0.000001 ? discount : Number(Number(discount).toFixed(2))
          }
          if (voucher && this.appliedVoucher) {
            Vue.set(this.appliedVoucher, 'discount', discount)
          }
          // console.log('Discount Get:', this.id, 'discount:', discount, 'voucher:', voucher)
          return discount
        },
        set: function (d) {
          // console.log('Discount Set:', d)
        }
      }
    },

    methods: {
      calculateStake (winning, caller) {
        if (!this.setter) {
          return
        }
        let s = null
        let v = winning || this.winning
        if (typeof v === 'number') {
          // let w = parseFloat(v.toFixed(2))
          let w = priceFormat.roundToPrecision(v, 2)
          s = w / (this.potentialReturn - this.unitCount)
          //
          // let d = s / this.unitStakeIncrement
          // d = parseFloat(d.toFixed(5))
          // d = Math.ceil(d)
          // s = d * this.unitStakeIncrement
          //
          s = priceFormat.roundToPrecision(s, 2)
        }
        // console.log('calculateStake for winning: ' + winning + ' (setter : ' + this.setter + ') -> ' + s, '; caller:', caller, '; isFastBet:', this.isFastBet)
//        this.stake = s
//        this.stake = s ? parseFloat(s.toFixed(2)) : null
        //
        if (s) {
          // s = parseFloat(s.toFixed(2))
          s = priceFormat.roundToPrecision(s, 2)
          if (this.stake !== s) {
            this.stake = s
          } else {
            // console.log('Stake already calculated and set!!; isFastBet:', this.isFastBet)
          }
        } else {
          this.stake = null
        }
        // clear setter last, after setting stake ^
        this.setter = null
      },
      calculateWinning (stake, caller) {
        let v = stake || this.stake
        let w = null
        if (typeof v === 'number') {
          // let s = parseFloat(v.toFixed(2))
          let s = priceFormat.roundToPrecision(v, 2)
          w = (this.potentialReturn - this.unitCount) * s
        }
        // console.log('calculateWinning for stake: ' + v + ' -> ' + w, '; Caller:', caller, '; isFastBet:', this.isFastBet)
        // console.log('w is:', typeof w, '; isNaN:' + isNaN(w))
//        this.winning = w
        //  this.winning = w ? parseFloat(w.toFixed(2)) : null
        if (typeof w === 'number') {
          // w = parseFloat(w.toFixed(2))
          w = priceFormat.roundToPrecision(w, 2)
          if (this.winning !== w) {
            this.winning = w
          } else {
            // console.log('Winning already calculated and set!!; isFastBet:', this.isFastBet)
          }
        } else {
          this.winning = null
        }
        //
        this.setter = null
        // console.log('calculateWinning for stake: ' + v + ' -> ' + w, '; this.winning:', this.winning)
      },
      setFocus (id, val) {
        // console.log('setFocus:', id, ':', val)
//        this.focus[id] = val
        if (val) {
          Vue.set(this.focus, 0, id)
        } else {
          if (id === 2) {
            this.setter = 'winning'
            this.calculateWinning(null, 'win-Kill-Focus')
          }
          if (this.focus[0] === id) {
            Vue.set(this.focus, 0, 0)
          }
        }
      },
      killFocus (id) {
        this.focus[id] = !true
      },
      dismissError (id, hasError) {
        // console.log('dismissError: ' + JSON.stringify(hasError))
        store.commit('sbBetslipState/dismissErrorFromSelection', hasError)
      },
      hasError (val) {
//        console.log('hasError: ' + JSON.stringify(val))
//        this.errors[val[0]] = val[1]
        Vue.set(this.errors, val[0], val[1])
      },
      clearSOVoucher (voucher) {
        // console.log('clearSOVoucher:', voucher)
        voucher = voucher || {}
        let vocherSO = voucher && voucher.Offers
        if (vocherSO && vocherSO.length) {
          let specialOffers = this.allowedBetTypesAndReturns && (this.allowedBetTypesAndReturns.SpecialOffers || this.allowedBetTypesAndReturns.SpecialOffer)
          let eligibleSO = (specialOffers && specialOffers['0']) || []
          for (let sov of vocherSO) {
            eligibleSO = eligibleSO.filter(so => {
              return !(so.source === 'SOvoucher' && so.id === sov.id)
            })
          }
          if (this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.Entity) {
            Vue.set(this.allowedBetTypesAndReturns, 'SpecialOffer', this.allowedBetTypesAndReturns.SpecialOffer || {})
            Vue.set(this.allowedBetTypesAndReturns.SpecialOffer, '0', eligibleSO)
          } else {
            Vue.set(this.allowedBetTypesAndReturns, 'SpecialOffers', this.allowedBetTypesAndReturns.SpecialOffers || {})
            Vue.set(this.allowedBetTypesAndReturns.SpecialOffers, '0', eligibleSO)
          }
        }
      },
      applySOVoucher (voucher) {
        // console.log('applySOVoucher:', voucher)
        let boosts = ['PARLAYBOOST', 'VOUCHERPARLAYBOOST', 'VOUCHERWINNINGBOOST']
        voucher = voucher || {}
        this.clearSOVoucher(voucher)
        let vocherSO = voucher && voucher.Offers
        if (vocherSO && vocherSO.length) {
          let specialOffers = this.allowedBetTypesAndReturns && (this.allowedBetTypesAndReturns.SpecialOffers || this.allowedBetTypesAndReturns.SpecialOffer)
          let eligibleSO = (specialOffers && specialOffers['0']) || []
          for (let sov of vocherSO) {
            sov.source = 'SOvoucher'
            sov.id = sov.Id
            if (boosts.includes(sov.Id) || sov.Id.includes('BOOST')) {
              sov.Id = 'PARLAYBOOST'
            }
            if (sov.Id.includes('PARLAYINSURANCE')) {
              sov.Id = 'PARLAYINSURANCE'
            }
            eligibleSO.push(sov)
          }
          if (this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.Entity) {
            Vue.set(this.allowedBetTypesAndReturns, 'SpecialOffer', this.allowedBetTypesAndReturns.SpecialOffer || {})
            Vue.set(this.allowedBetTypesAndReturns.SpecialOffer, '0', eligibleSO)
          } else {
            Vue.set(this.allowedBetTypesAndReturns, 'SpecialOffers', this.allowedBetTypesAndReturns.SpecialOffers || {})
            Vue.set(this.allowedBetTypesAndReturns.SpecialOffers, '0', eligibleSO)
          }
        }
      },
      applyVoucher () {
        // console.log('apply voucher on:', this.id)
        if (!this.autoFillStakeByVoucher) {
          return
        }
        // console.log('apply voucher on:', this.id)
        let voucher = this.applicableVoucher || {}
        let isPartiallyUsable = voucher.IsPartiallyUsable
        let discountPercentage = voucher.DiscountPercentage || 0
        let amount = voucher.CurrentAmount || 0
        let stake = (!isPartiallyUsable && discountPercentage && amount) || 0
        if (stake) {
          stake = (stake * 100) / discountPercentage
          stake = Number(Number(stake).toFixed(2))
          stake = stake / this.unitCount
          stake = Number(Number(stake).toFixed(2))
        }
        this.freshFromGet = false
        this.stake = stake || ''
        setTimeout(() => {
          if (!this.stake && voucher && voucher.IDMMPRVoucher) {
            this.$refs.wagerInput.$refs.moneyValue.focus()
          }
        }, 0)
      },
      printJSON (obj) {
        obj = obj || {}
        return JSON.stringify(obj, null, 4)
          .replace(/\n( *)/g, function (match, p1) {
            return '<br>' + '&nbsp;'.repeat(p1.length)
          })
      }
    },

    created () {
    },

    mounted () {
      if (this.appliedVoucher && this.appliedVoucher.betId && this.betId === this.appliedVoucher.betId) {
        Vue.set(this.appliedVoucher, 'isBetAvailable', true)
      }
    },

    watch: {
      /*
      errors: {
        immediate: true,
        handler (newVal, oldVal) {
          console.log('Watch errors: ')
          console.log(JSON.stringify(newVal))
        }
      },
      */
      currentBetSlipState: {
        immediate: true,
        handler (newVal, oldVal) {
//          console.log('currentBetSlipState: ' + oldVal + ' => ' + newVal)
          this.$emit('hideBetType', (newVal > 1 && !this.stake))
          //
          if (newVal <= 1) {
            Vue.set(this, 'showMoneyInput', true)
            Vue.set(this, 'inRefferalStakeChanged', false)
            Vue.set(this, 'nonReferalStakeChanged', false)
          }
        }
      },
      statusToConfirm: {
        immediate: true,
        handler (newVal, oldVal) {
//          console.log('statusToConfirm: ' + oldVal + ' => ' + newVal)
          if (oldVal === 'Rejected' && this.currentBetSlipState === 10) {
            this.$emit('hideBetType', true)
            if (this.perType === 'PerSelection') {
              Vue.set(this, 'showMoneyInput', false)
            }
          }
        }
      },
      potentialReturn: {
        immediate: true,
        handler (newVal, oldVal) {
          // console.log('potentialReturn (' + this.perType + ') ' + this.id + ': ' + oldVal + ' => ' + newVal, '; isFastBet:' + this.isFastBet)
          if (newVal) {
            this.setter = 'winning'
            this.calculateWinning(null, 'potentialReturn')
//          Vue.set(this, 'stake', this.stake)
          }
        }
      },
      multiSinglesStake: {
        immediate: !true,
        handler (newVal, oldVal) {
         // console.log('multiSinglesStake (' + this.perType + ') ' + this.id + ': ' + oldVal + ' => ' + newVal)
          if (this.perType === 'PerSelection') {
            let s = newVal || ''
            Vue.set(this, 'stake', s)
            this.calculateWinning(s, 'multiSinglesStake')
          }
        }
      },
      stake: {
        immediate: true,
        handler (newVal, oldVal) {
          // console.log('Stake (' + this.id + ') changed: ' + oldVal + ' -> ' + newVal + ' type: ' + typeof newVal + '; setter: ' + this.setter)
          let ov = (oldVal && !isNaN(oldVal) && parseFloat((1 * oldVal).toFixed(2))) || 0
          let nv = (newVal && !isNaN(newVal) && parseFloat((1 * newVal).toFixed(2))) || 0
          if (nv && nv !== ov) {
            // this.stakeChange = {old: (oldVal && parseFloat((1 * oldVal).toFixed(2))) || 0, new: newVal}
            this.stakeChange = {old: ov, new: nv}
            this.inRefferalStakeChanged = this.inRefferal
            this.nonReferalStakeChanged = this.currentBetSlipState && !this.inRefferal
          }
          if (nv !== ov) {
            if (this.inRefferal || this.currentBetSlipState) {
              this.setter = 'wager'
              this.calculateWinning(newVal, 'stake-Watcher')
            }
          }
          if (newVal && this.isFastBet) {
            store.commit('sbBetslipState/setSingleBetSlipStake', newVal)
          }
        }
      },
      appliedVoucherId: {
        immediate: false,
        handler (newVal, oldVal) {
          // console.log('Watch appliedVoucherId (' + this.id + ') changed: ' + oldVal + ' -> ' + newVal)
          this.applyVoucher()
        }
      },
      disabledByVoucher: {
        immediate: false,
        handler (newVal, oldVal) {
          // console.log('Watch disabledByVoucher (' + this.id + ') changed: ' + oldVal + ' -> ' + newVal)
          if (newVal) {
            // console.log('clear stake for', this.id)
            this.stake = ''
          }
        }
      },
      applicableVoucher: {
        immediate: false,
        handler (newVal, oldVal) {
          // console.log('Watch applicableVoucher (', this.id, ') changed: ', oldVal, ' -> ', newVal)
          // if (oldVal && (!newVal || newVal.IDMMPRVoucherType !== oldVal.IDMMPRVoucherType)) {
          if (oldVal) {
            this.clearSOVoucher(oldVal)
          }
          if (newVal) {
            this.applySOVoucher(newVal)
          }
        }
      }
    },

    destroyed () {
    },
    beforeDestroy () {
      if (this.appliedVoucher && this.appliedVoucher.betId && this.betId === this.appliedVoucher.betId) {
        // console.log('beforeDestroy', this.applicableVoucher)
        Vue.set(this.appliedVoucher, 'isBetAvailable', false)
        Vue.set(this.appliedVoucher, 'discount', 0)
        setTimeout(() => {
          // console.log('this.appliedVoucher:', this.appliedVoucher)
          if (this.applicableVoucher && !this.appliedVoucher.isActive) {
            // console.log('clear onDestroy applicableVoucher:', this.applicableVoucher)
            this.clearSOVoucher(this.applicableVoucher)
          }
        }, 0)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"
  .stake-line {
    color: #000;
    display: flex;
    > span {
      text-align: center;
      margin-right: 8px;
      flex: 1;

      &:last-child {
        margin-right: 0;
      }
      /*padding: 3px;*/
    }
    span.label-returns {
      width: 23%;
    }
  }
  .voucher {
    margin: 4px 0 0px 0;
    .discount {
      color: #06283b;
      font-weight: bold;
    }
  }
  .error-msg
    display: flex
    padding: 10px
    margin: 7px 0px 0
    background-color: rgba(228, 66, 66, 0.1)
    color: #DB3F3F
    font-weight: normal
    text-transform: uppercase
    text-align: left
    font-size: 12px
    line-height: 14px
    align-items: center
    justify-content: left
    .v-icon
      color red
</style>



// WEBPACK FOOTER //
// src/components/sports/betslipV2/common/stakeNreturn.vue